import React, { useEffect, useState } from 'react';
import { XMarkIcon } from '@heroicons/react/24/outline';
import ResponsiveModal from '../ui/ResponsiveModal';

const QualityDepartmentModal = ({ isOpen, onClose, onSave, initialData = null, hotels = [] }) => {
  const [hotelId, setHotelId] = useState('');
  const [departmentName, setDepartmentName] = useState('');
  const [depCode, setDepCode] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    if (!isOpen) {
      document.body.style.overflow = 'unset';
      return;
    }

    document.body.style.overflow = 'hidden';
    setHotelId(initialData?.hotel_id ? String(initialData.hotel_id) : (hotels[0]?.id ? String(hotels[0].id) : ''));
    setDepartmentName(initialData?.department_name || '');
    setDepCode(initialData?.dep_code || '');
    setError('');

    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen, initialData, hotels]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!hotelId) {
      setError('Otel seçimi zorunludur.');
      return;
    }
    if (!departmentName.trim()) {
      setError('Departman adi zorunludur.');
      return;
    }

    await onSave({
      hotel_id: Number(hotelId),
      department_name: departmentName.trim(),
      dep_code: depCode.trim() || null,
    });
  };

  return (
    <ResponsiveModal isOpen={isOpen} onClose={onClose} className="max-w-lg">
      <div className="flex items-center justify-between px-6 py-4 border-b border-gray-200 dark:border-gray-700">
        <h2 className="text-lg font-semibold text-gray-900 dark:text-white">
          {initialData ? 'Departman Duzenle' : 'Yeni Departman'}
        </h2>
        <button type="button" onClick={onClose} className="text-gray-500 hover:text-gray-700 dark:hover:text-gray-300">
          <XMarkIcon className="w-5 h-5" />
        </button>
      </div>

      <form onSubmit={handleSubmit} className="p-6 space-y-4">
        {error && <div className="text-sm text-red-600 dark:text-red-400">{error}</div>}
        <select
          value={hotelId}
          onChange={(e) => setHotelId(e.target.value)}
          className="w-full border border-gray-300 dark:border-gray-600 rounded-md px-3 py-2 bg-transparent text-gray-900 dark:text-gray-100"
        >
          <option value="">Otel seçiniz</option>
          {hotels.map((item) => (
            <option key={item.id} value={item.id}>{item.hotel_name}</option>
          ))}
        </select>
        <input
          value={departmentName}
          onChange={(e) => setDepartmentName(e.target.value)}
          placeholder="Departman adi"
          className="w-full border border-gray-300 dark:border-gray-600 rounded-md px-3 py-2 bg-transparent text-gray-900 dark:text-gray-100 placeholder:font-semibold placeholder:text-gray-400 dark:placeholder:text-gray-500"
        />
        <input
          value={depCode}
          onChange={(e) => setDepCode(e.target.value)}
          placeholder="Departman kodu (opsiyonel)"
          className="w-full border border-gray-300 dark:border-gray-600 rounded-md px-3 py-2 bg-transparent text-gray-900 dark:text-gray-100 placeholder:font-semibold placeholder:text-gray-400 dark:placeholder:text-gray-500"
        />
        <div className="flex justify-end gap-3">
          <button type="button" onClick={onClose} className="px-4 py-2 rounded-md border border-gray-300 dark:border-gray-600 text-sm text-gray-700 dark:text-gray-200">
            Iptal
          </button>
          <button type="submit" className="px-4 py-2 rounded-md bg-blue-600 text-white text-sm">
            {initialData ? 'Guncelle' : 'Kaydet'}
          </button>
        </div>
      </form>
    </ResponsiveModal>
  );
};

export default QualityDepartmentModal;
